module.exports = __webpack_public_path__ + "static/media/12.3f7785c3.JPG";